<template>
	<div ref="container" class="z-1 absolute left-6 top-6 flex gap-1.5 text-white" can-undo="true" can-redo="true">
		<i
			v-for="action in actions"
			:key="action.title"
			:class="action.classes"
			:title="action.title"
			@click="action.method"
		>
			<span :class="action.icon"></span>
		</i>
	</div>
</template>

<script>
import { loadSurface } from '@jsplumbtoolkit/browser-ui-vue3'
import { EVENT_UNDOREDO_UPDATE, EVENT_CANVAS_CLICK, SurfaceMode, uuid } from '@jsplumbtoolkit/browser-ui'

let container
let surfaceId

function _getSurface(cb) {
	loadSurface(surfaceId, cb)
}

export default {
	props: {
		surfaceId: {
			type: String
		}
	},
	data() {
		return {
			actions: [
				{
					title: 'Zoom In',
					classes:
						'flex size-7 cursor-pointer items-center justify-center rounded-sm text-black bg-white text-2xl hover:bg-stone-200',
					icon: 'fa-light fa-magnifying-glass-plus scale-75',
					method: this.zoomIn
				},
				{
					title: 'Zoom Out',
					classes:
						'flex size-7 cursor-pointer items-center justify-center rounded-sm text-black bg-white text-2xl hover:bg-stone-200',
					icon: 'fa-light fa-magnifying-glass-minus scale-75',
					method: this.zoomOut
				},
				{
					title: 'Zoom To Fit',
					classes:
						'flex size-7 cursor-pointer items-center justify-center rounded-sm bg-blue-400 text-2xl hover:bg-blue-500',
					icon: 'fa-light fa-arrow-down-left-and-arrow-up-right-to-center scale-75',
					method: this.zoomToFit
				},
				{
					title: 'Undo',
					classes:
						'flex size-7 cursor-pointer items-center justify-center rounded-sm bg-orange-500 text-2xl hover:bg-orange-600',
					icon: 'fa-light fa-undo scale-75',
					method: this.undo
				},
				{
					title: 'Redo',
					classes:
						'flex size-7 cursor-pointer items-center justify-center rounded-sm bg-orange-500 text-2xl hover:bg-orange-600',
					icon: 'fa-light fa-redo scale-75',
					method: this.redo
				},
				{
					title: 'Clear',
					classes:
						'flex size-7 cursor-pointer items-center justify-center rounded-sm bg-red-500 text-2xl hover:bg-red-600',
					icon: 'fa-light fa-close scale-75',
					method: this.clear
				}
			]
		}
	},
	mounted() {
		surfaceId = this.surfaceId
		container = this.$refs.container
		_getSurface((surface) => {
			surface.toolkitInstance.bind(EVENT_UNDOREDO_UPDATE, (state) => {
				container.setAttribute('can-undo', state.undoCount > 0 ? 'true' : 'false')
				container.setAttribute('can-redo', state.redoCount > 0 ? 'true' : 'false')
			})

			surface.bind(EVENT_CANVAS_CLICK, () => {
				surface.toolkitInstance.clearSelection()
			})
		})
	},
	methods: {
		zoomIn() {
			_getSurface((s) => s.nudgeZoom(0.2))
		},
		zoomOut() {
			_getSurface((s) => s.nudgeZoom(-0.2))
		},
		zoomToFit() {
			_getSurface((s) => s.zoomToFit())
		},
		undo() {
			_getSurface((s) => s.toolkitInstance.undo())
		},
		redo() {
			_getSurface((s) => s.toolkitInstance.redo())
		},
		clear() {
			_getSurface((s) => {
				const t = s.toolkitInstance
				if (t.getNodeCount() === 0 || confirm('Clear canvas?')) {
					t.clear()
					t.load({
						data: {
							nodes: [
								{
									id: uuid(),
									type: 'entrypoint',
									name: 'Entry Point',
									top: 50,
									left: 20,
									config: {
										node_id: 'entrypoint'
									}
								}
							],
							edges: []
						},
						type: 'json'
					})
				}
			})
		}
	}
}
</script>
